import { HTTP } from '@/http-common'

function getBuilding (buildingId) {
  return HTTP.get('/buildings/' + buildingId)
}

function addBuilding (buildingData) {
  let data = JSON.stringify(buildingData)

  return HTTP.post('/buildings', data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function updateBuilding (buildingData) {
  let data = JSON.stringify(buildingData)

  return HTTP.put('/buildings/' + buildingData.id, data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function deleteBuilding (buildingId) {
  return HTTP.delete('/buildings/' + buildingId)
}

export { getBuilding, addBuilding, updateBuilding, deleteBuilding }



// WEBPACK FOOTER //
// ./src/services/building.service.js